<template>
  <div class="index">
    <!-- <vhead v-on:menuFlag='menuShow'></vhead> -->
    <!-- <sidebar v-if="MenuShowFlag" v-on:menuFlag="menuShow"></sidebar> -->
    <sidebar v-if="MenuShowFlag"></sidebar>
    <i @click="openMenu()" class="iconfont icon-menu hidden-sm-and-up"></i>
    <div class="content-box">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
import vhead from "./Header.vue";
import sidebar from "./Sidebar.vue";
export default {
  data() {
    return {
      // MenuShowFlag: document.body.clientWidth >= 768 ? true : false
      MenuShowFlag:true
    };
  },
  created() {
    console.log(this.$route.path);
    let version = "3.6.31";
    this.$get(
      `/request/version/getUpdateStatus?version=${version}`,
      this.$GLOBAL.jsonConfig
    ).then(res => {
      console.log(res);
      if (res.code !== "00000") {
        this.$confirm(res.message, "提示", {
          confirmButtonText: "立即刷新",
          center: true,
          closeOnClickModal: false,
          showCancelButton: false
        }).then(res => {
          window.location.reload();
        });
      }
    });
  },
  methods: {
    // menuShow(data) {
    //   let _this = this;
    //   _this.MenuShowFlag = data;
    // },
    openMenu() {
      this.MenuShowFlag = true;
    }
  },
  components: {
    sidebar
  }
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  height: 100%;
  background: #f5f5fc;
  overflow: hidden;
  .icon-menu {
    position: absolute;
    left: 0.2rem;
    top: 0.2rem;
    z-index: 101;
  }
  .content-box {
    width: auto;
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
  }
}
@media screen and (max-width: 767px) {
  .index {
    padding-left: 0;
  }
}
@media screen and (min-width: 768px) {
  .index {
    padding-left: 2.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue